<template>
    <div class="apprentice-simple-card">
        <h4>{{ lasImportLogName }}</h4>
        <p>Bron: {{ lasImportLogIn.provider }}</p>
        <h6>{{ $t('school.failed') }}</h6>
        <ul>
            <li>
                {{ $t('school.groups') }}
                <span class="text-success">{{ lasImportLogIn.groups_done }}</span>
                /
                <span class="text-danger">{{ 0 + lasImportLogIn.groups_failed }}</span>
            </li>
            <li>
                {{ $t('school.main_groups') }}
                <span class="text-success">{{ lasImportLogIn.main_groups_done }}</span>
                /
                <span class="text-danger">{{ 0 + lasImportLogIn.main_groups_failed }}</span>
            </li>
            <li>
                {{ $t('school.students') }}
                <span class="text-success">{{ lasImportLogIn.students_done }}</span>
                /
                <span class="text-danger">{{ 0 + lasImportLogIn.students_failed }}</span>
            </li>
            <li>
                {{ $t('school.teachers') }}
                <span class="text-success">{{ lasImportLogIn.teachers_done }}</span>
                /
                <span class="text-danger">{{ 0 + lasImportLogIn.teachers_failed }}</span>
            </li>
        </ul>

        <design-2021-apprentice-data-table
            :fields="logFields"
            :items="tableData">
            <template v-slot:cell(exception)="data">
                <pre
                    class="error-message"
                    v-if="data.item.exception"
                    >{{ data.item.exception }}</pre
                >
                <span v-else>{{ $t('school.no_error_message') }}</span>
            </template>

            <template v-slot:cell(lasData)="data">
                <pre v-if="data.item.lasData">{{ data.item.lasData }}</pre>
                <span v-else>{{ $t('school.no_date') }}</span>
            </template>
        </design-2021-apprentice-data-table>
    </div>
</template>

<script>
export default {
    name: 'design-2021-school-las-import-log-component',
    props: ['lasImportLogIn'],
    data() {
        return {
            logFields: [
                {
                    key: 'description',
                    label: this.$t('common.description'),
                },
                {
                    key: 'exception',
                    label: this.$t('school.error_message'),
                },
                {
                    key: 'lasData',
                    label: 'Data',
                },
                {
                    key: 'createdAt',
                    label: this.$t('school.happened_at'),
                },
            ],
            lasImportLogName:
                'LAS-import van ' +
                this.lasImportLogIn.las_location.school.name +
                ' (' +
                this.lasImportLogIn.las_location.school_id +
                ') op ' +
                this.importDateTime(this.lasImportLogIn.created_at),
        };
    },

    computed: {
        tableData() {
            return this.lasImportLogIn.activity_logs.map((log) => {
                return {
                    id: log.id,
                    description: log.description,
                    exception: log.properties.exception,
                    lasData: log.properties.lasData,
                    createdAt: this.importDateTime(log.created_at),
                };
            });
        },
    },

    methods: {
        importDateTime(createdAt) {
            let date = new Date(createdAt);
            let minutes = date.getMinutes();
            if (minutes < 10) {
                minutes = '0' + minutes;
            }
            let seconds = date.getSeconds();
            if (seconds < 10) {
                seconds = '0' + seconds;
            }
            return date.toISOString().split('T')[0] + ' ' + date.getHours() + ':' + minutes + ':' + seconds;
        },
    },
};
</script>

<style scoped>
.error-message {
    text-wrap: wrap;

    @media (min-width: 576px) {
        max-width: 33vw;
    }
}
</style>
